var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsurance = function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.958 8.8c-.325 2.854-.208 7.022 1.208 11.127 1.496 4.336 4.43 8.585 9.832 11.189 5.402-2.604 8.342-6.854 9.842-11.19 1.42-4.105 1.543-8.273 1.219-11.126H8.958ZM31.76 8H8.256c-.88 5.89.042 18.61 11.742 24 11.7-5.39 12.642-18.11 11.763-24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 29V11H11.02c-.428 10.286 5.808 16.286 8.98 18Z",
    fill: "currentColor"
  })));
};
export default SvgInsurance;